<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search class="pt-3" placeholder="客户名称" @search="searchEvent">
			<!-- 左边按钮 -->
			<template #left>
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="navigate('khgl_khgl_khxx_create')">添加</el-button>
				<el-button type="success" icon="el-icon-warning-outline" size="mini" @click="czthm" style="margin-right: 10px;">重置提货码</el-button>
				<el-select v-model="dqck" filterable style="width: 100px;" size="mini" @change="curr">
				    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</template>
			<!-- 高级搜索 表单 -->
			<template #form>
				<el-form inline ref="form" :model="search" label-width="80px">
					<!-- 搜索内容 -->
					<el-form-item label="客户编号" class="mb-0">
						<el-input v-model="search.bh" size="mini" placeholder="客户编号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>

			</template>
		</button-search>
		<el-tabs v-model="tabIndex" @tab-click="getList" class="mt-2">
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{tab.name}}</div>
					<div v-if="tab.num != 0" style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;" class="d-flex">
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{tab.num}}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>

		<el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column align="center" prop="j_name" width="70" label="客户简称" fixed="left"></el-table-column>
			<el-table-column align="center" prop="name" label="客户名称" width="120" fixed="left"></el-table-column>
			<el-table-column align="center" label="客户类型" width="90">
				<template slot-scope="scope">
					{{scope.row.khlx.mc}}
				</template>
			</el-table-column>
			<el-table-column prop="city" width="180" label="地址"></el-table-column>
			<el-table-column prop="phone" width="100" label="电话"></el-table-column>
			<el-table-column prop="" width="130" label="手机(通知收费)">
				<template slot-scope="scope">
					{{scope.row.sf_phone}}
				</template>
			</el-table-column>
			<el-table-column prop="" width="130" label="手机(通知到货)">
				<template slot-scope="scope">
					{{scope.row.dh_phone}}
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="锁定状态">
				<template slot-scope="scope">
					<el-button :type="scope.row.locking == 0 ? 'success' : 'primary'" size="mini" plain>{{scope.row.locking == 0 ? '无' : scope.row.locking == 1 ? '冷藏锁定' : scope.row.locking == 2 ? '待付运费锁定' : '运费锁定' }}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" label="计算运费" width="120">
				<template slot-scope="scope">
					{{scope.row.jsyf == 1 ? '月结运费' : '当次结算运费'}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="收押金" width="90">
				<template slot-scope="scope">
					<el-button :type="scope.row.syj == 1 ? 'success' : 'warning'" :icon="scope.row.syj == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column>
			<el-table-column prop="yjje" width="100" align="center" label="押金金额"></el-table-column>
			<el-table-column align="center" label="包仓" width="90">
				<template slot-scope="scope">
					<el-button :type="scope.row.bc == 1 ? 'success' : 'warning'" :icon="scope.row.bc == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="zdkcl" width="80" label="最低库存量"></el-table-column>
			<el-table-column align="center" label="开通微信" width="90">
				<template slot-scope="scope">
					<el-button :type="scope.row.ktwx == 1 ? 'success' : 'warning'" :icon="scope.row.ktwx == 1 ? 'el-icon-check' : 'el-icon-close'" circle size="mini"></el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" label="计算单位" width="90">
				<template slot-scope="scope">
					{{scope.row.jfdw == null ? '' : scope.row.jfdw.name}}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="jfzq" width="100" label="计费周期"></el-table-column>
			<el-table-column align="center" prop="yfdj" width="100" label="运费单价"></el-table-column>
			<el-table-column align="center" label="线路" width="90">
				<template slot-scope="scope">
					{{scope.row.xl == null ? '' : scope.row.xl.name}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="货运方式" width="90">
				<template slot-scope="scope">
					{{scope.row.thlx == null ? '' : scope.row.thlx.name}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="自提码方式" width="90">
				<template slot-scope="scope">
					{{scope.row.ztmfs == 1 ? '一票一码' : '一天一码'}}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="thm" width="120" label="提货码">
			</el-table-column>
			<el-table-column align="center" width="60" label="二维码">
				<template slot-scope="scope">
					<img :src="scope.row.thm_url" style="width: 20px;height: 20px;" @click="cktp(scope.row)">
				</template>
			</el-table-column>
			<el-table-column align="center" label="最后变更时间" width="200">
				<template slot-scope="scope">
					{{scope.row.update_time}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="最后操作人" width="120">
				<template slot-scope="scope">
					{{scope.row.czr == null ? '' : scope.row.czr.name}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<!-- <el-button type="primary" size="mini" @click="navigate('khgl_khgl_khxx_ck',scope.row)">查看</el-button> -->
					<el-button type="primary" size="mini" @click="navigate('khgl_khgl_khxx_create',scope.row)">编辑</el-button>
					<!-- <el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button> -->
					<el-select v-model="value" placeholder="更多" size="mini" style="width: 75px;margin-left: 10px;">
						<el-option value="1"><p @click="navigate('khgl_khgl_khxx_khzl',scope.row)">客户资料</p></el-option>
						<el-option value="2"><p @click="navigate('khgl_khgl_khxx_jfpz',scope.row)">计费配置</p></el-option>
						<el-option value="3"><p @click="openModel('ccsd',scope.row)" :style="{  color: scope.row.sfsd == 1 ? '#fa0000': '#0057fa' }">出仓锁定</p></el-option>
						<el-option value="4"><p @click="openModel('cfkc',scope.row)">存放库存</p></el-option>
						<!-- <el-option value="4"><p @click="navigate('khgl_khgl_khxx_kpxx',scope.row)">开票信息</p></el-option> -->
					</el-select>
				</template>
			</el-table-column>
		</el-table>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>

		<el-dialog title="出仓锁定" :visible.sync="createModel" top="10vh" :before-close="handleClose" width="70%">
			<el-form ref="form" label-width="80px">
				<div class="d-flex">
					<div style="width: 33%;">
						<el-form-item label="开始日期">
							<el-date-picker v-model="khsd.sd_time" align="right" type="date" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;" @change="sjc"></el-date-picker>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="锁定周期">
							<el-input-number v-model="khsd.sdts" size="mini" @change="sjc"></el-input-number>
							<span style="margin-left: 8px;">天</span>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="锁定人">
							<div>{{user.name}}</div>
						</el-form-item>
					</div>
				</div>
				<div class="d-flex">
					<div style="width: 33%;">
						<el-form-item label="结束日期">
							<div style="color: red;">{{khsd.js_time}}</div>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="锁定理由">
							<el-input v-model="khsd.sdly" style="width: 95%;" type="textarea" :rows="2"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="锁定状态">
							<el-select v-model="khsd.locking" placeholder="请选择" size="mini" style="width: 94%;">
								<el-option v-for="item in sdztlist" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</div>
				</div>
				<div class="d-flex">
					<div style="width: 100%;">
						<el-form-item label="是否锁定">
							<el-radio-group v-model="khsd.sfsd">
							    <el-radio :label="0">解除锁定</el-radio>
							    <el-radio :label="1">锁定客户</el-radio>
							  </el-radio-group>
						</el-form-item>
					</div>
				</div>
			</el-form>
			<div style="font-weight: 800;margin-bottom: 10px;">上一次锁定信息：</div>
			<div style="width: 100%;" class="d-flex">
				<div style="width: 50%;">
					开始日期：{{syc_khsd.sd_time}}
				</div>
				<div style="width: 50%;">
					解锁日期：{{syc_khsd.js_time}}
				</div>
			</div>
			<div style="width: 100%;" class="d-flex">
				<div style="width: 50%;">
					锁定周期：{{syc_khsd.sdts}}天
				</div>
				<div style="width: 50%;">
					锁定人：{{syc_khsd.sdr === 0 ? '系统终端' : syc_khsd.sdrxx.name}}
				</div>
			</div>
			<div style="width: 100%;" class="d-flex">
				<div style="width: 50%;">
					状态：{{syc_khsd.sfsd == 0 ? '未锁定' : '已锁定'}}
				</div>
				<div style="width: 50%;">
					锁定状态：{{syc_khsd.locking == 0 ? '无' : syc_khsd.locking == 1 ? '冷藏锁定' : syc_khsd.locking == 2 ? '待付运费锁定' : '运费锁定' }}
				</div>
			</div>
			<div style="width: 100%;">
				锁定理由：{{syc_khsd.sdly}}
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gbym">取 消</el-button>
				<el-button type="primary" @click="qrtj">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提货二维码" :visible.sync="cktpstatus" top="10vh" :before-close="cktpClose">
			<!-- 表单内容 -->
			<div class="d-flex" style="justify-content: center;">
				<img :src="cktpurl.thm_url" style="width: 200px;height: 200px;">
			</div>
		</el-dialog>

		<el-dialog title="存放库存" :visible.sync="createModelck" top="10vh" :before-close="handleClose" width="70%">
			<el-form ref="form" label-width="80px">
				<div class="d-flex">

				</div>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="gbym">取 消</el-button>
				<el-button type="primary" @click="qrtj">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'khxx',
			createModel: false,
			createModelck:false,
			khcfkc:[],
			tabIndex: 0,
			tabbars: [{ name: '全部', key: 'all' ,num:0}, { name: '普通客户', key: 'ptkh' ,num:0},{ name: '优惠客户', key: 'yhkh' ,num:0},{ name: '包仓客户', key: 'bckh' ,num:0},{ name: '私库客户', key: 'skkh' ,num:0}, { name: '月结运费', key: 'yjyf' ,num:0}, { name: '锁定出仓', key: 'sdcc' ,num:0}],
			form: {
				khxx: {
					title: '',
					content: ''
				}
			},
			cktpstatus: false,
			cktpurl: {},
			tableData: [],
			maxHeight: 0,
			multipleSelection:[],
			value:'更多',
			search: {
				keyword: "",
				bh:''
			},
			khsd:{
				sfsd:1,
				sdts:1,
				sd_time:'',
				sdr:0,
				js_time:'',
				sdly:'',
				kh_id:'',
				locking:0
			},
			syc_khsd:{
				sdrxx:''
			},
			dqck:0,
			cklist:[],
			sdztlist: [
				{
					value: 0,
					label: '无'
				},
				{
					value: 1,
					label: '冷藏锁定'
				},
				{
					value: 2,
					label: '待付运费锁定'
				},
				{
					value: 3,
					label: '运费锁定'
				}
			],
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 300;
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
			this.cklist.unshift({
				id: 0,
				name: '全部'
			})
		});
	},
	methods: {
		curr(val){
			this.dqck = val
			this.getList()
		},
		// 鼠标单击的事件
		navigate(name, e) {
			// 初始化表单
			if(!e){
				var data = {
					name: '',
					phone: '',
					flflx_id: 1,
					jsyf: 0,
					j_name: '',
					sf_phone: '',
					jfdw_id: '',
					jfzq: 1,
					desc: '',
					dh_phone: '',
					lb_id: 1,
					sfzzk: 0,
					city: '',
					hyfs: '',
					ztmfs: '',
					syj: 0,
					xl_id: '',
					thr: '',
					yfzfr: '',
					zdkcl:0,
					yfdj:0,
					yjje:0,
					jymy:'',
					dkcity:'',
					sfz:'',
					hyfs_bcdw:'',
					hyfs_dj:0,
					thm:'',
					ck_id:1
				}
			}else if(name == 'khgl_khgl_khxx_jfpz'){
				var data = e
			}else{
				var data = {
					id:e.id,
					name: e.name,
					phone: e.phone,
					flflx_id: e.flflx_id,
					jsyf: e.jsyf,
					j_name: e.j_name,
					sf_phone: e.sf_phone,
					jfdw_id: e.jfdw_id,
					jfzq: e.jfzq,
					desc: e.desc,
					dh_phone: e.dh_phone,
					lb_id: e.lb_id,
					sfzzk: e.sfzzk,
					city: e.city,
					hyfs: e.hyfs,
					ztmfs: e.ztmfs,
					syj: e.syj,
					xl_id: e.xl_id,
					thr: e.thr,
					yfzfr: e.yfzfr,
					zdkcl:e.zdkcl,
					yfdj:e.yfdj,
					yjje:e.yjje,
					jymy:e.jymy,
					dkcity:e.dkcity,
					sfz:e.sfz,
					hyfs_bcdw:e.hyfs_bcdw,
					hyfs_dj:e.hyfs_dj,
					thm:e.thm,
					ck_id:e.ck_id
				}
			}
			this.$router.push({
				name,
				params: { data }
			})
		},
		navigates(name, e) {
			if(e.length == 0){
				this.$message({
						type: 'success',
						message: '请选择客户'
					});
			}else{
				let x = e.map(i=>{
					return i.id
				})
				let f = e.map(i=>{
					return {
						id:i.id,
						mc:i.mc,
						zrr:i.zrr.name,
					}
				})
				let i = {
					khxx:f,
					ids:x,
				}
				this.$router.push({
					name,
					params: { i }
				})
			}

		},
		onClick(e, editor) {},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
					this.value = '更多'
					this.formzxg = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					}
					this.formlhy = {
						id:'',
						sysl:0,
						ce:0,
						list:[]
					}
				})
				.catch(_ => {});
		},
		upstate(e, f) {
			this.axios
				.post('/admin/khxx/' + e + '/update_status', { state: f }, { token: true })
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}&keyword=${this.search.keyword}&bh=${this.search.bh}&dqck=${this.dqck}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list
			this.tabbars[3].num = e.sfsd
		},
		states(f){
			let x = f.map(i=>{
				return i.id
			})
			let i = {
				sfr:this.user.id,
				sfsj:this.times(),
				ids:x,
			}
			this.axios.post('/admin/khxx/frgh', i,{
				token: true
			}).then(res => {
				this.getList()
			})
		},
		handleSelectionChange(val) {
		        this.multipleSelection = val;
		},
		times(){
			let nowdate = new Date();
			let y =  nowdate.getFullYear()
			let m = nowdate.getMonth() + 1
			let r = nowdate.getDate()
			if(m<10){
				m = '0'+m
			}
			if(r<10){
				r = '0'+r
			}
			let days = y + '-' + m + '-' + r
			return days
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.keyword = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				keyword: "",
				bh: '',
			}
		},
		openModel(type, item = false) {
			if(type == 'ccsd'){
				if (item) {
					this.khsd.kh_id = item.id
					this.syc_khsd = item
				}
				console.log(item,this.khsd)
				// 打开dialog
				this.createModel = true;
			}else if(type == 'cfkc'){
				this.axios.get('/admin/khck', { token: true }).then(res => {
					this.khcfkc = res.data.data;

				});
				// 打开dialog
				this.createModelck = true;
			}
		},
		gbym(){
			this.value = '更多'
			// this.formzxg = {
			// 	id:'',
			// 	sysl:0,
			// 	ce:0,
			// 	list:[]
			// },
			// this.formlhy = {
			// 	id:'',
			// 	sysl:0,
			// 	ce:0,
			// 	list:[]
			// },
			// this.formhw = []
			// this.hwlist = []
			this.createModel = false
		},
		qrtj(){
			this.khsd.sdr = this.user.id
			this.axios.post('/admin/kh_ccsd', this.khsd, {
				token: true
			}).then(res => {
				this.$message({
					type: "success",
					message: "修改成功"
				})
				this.getList()
				this.value = '更多'
				this.khsd = {
					sfsd:1,
					sdts:1,
					sd_time:'',
					sdr:0,
					js_time:'',
					sdly:'',
					kh_id:'',
					locking:0
				},
				this.createModel = false
			})
		},
		sjc(){
			if(this.khsd.sd_time != ''){
				var targetDate = new Date(this.khsd.sd_time);
				var day = targetDate.setDate(targetDate.getDate() + this.khsd.sdts)
				this.khsd.js_time = this.timestampToYYYYMMDD(day)
			}

		},
		timestampToYYYYMMDD(timestamp) {
		  const date = new Date(timestamp); // 将时间戳转换为Date对象
		  const year = date.getFullYear();
		  const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份需要加1，且保证两位数显示
		  const day = ("0" + date.getDate()).slice(-2); // 保证日期显示两位数
		  return year +'-'+ month +'-'+ day;
		},
		czthm(){
			this.axios.get('/admin/czthm', {
				token: true
			}).then(res => {
				this.$message({
					type: "success",
					message: "重置成功"
				})
				this.getList()
			})
		},
		cktp(e){
			this.cktpstatus = true
			this.cktpurl = e
		},
		cktpClose(){
			this.cktpstatus = false
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
